import { Card, Image, Label } from 'semantic-ui-react'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Slider from '../components/Slider'
import _ from 'lodash'

function TechnologyItem(props) {
	const logo = props.logo ? (
		<a target="_new" href={props.quoteSource}>
			<Image floated="right" size="mini" src={`/img/tech-logos/${props.logo}`} />
		</a>
	) : (
		false
	)
	return (
		<Card centered>
			<Card.Content>
				{logo}
				<Card.Header>{props.title}</Card.Header>
				<Card.Meta>
					<a href={props.quoteSource} target="_new">
						<em>{props.quote}</em>
					</a>
				</Card.Meta>
				<Card.Description>
					{props.description ? props.description : false}
				</Card.Description>
				{props.highlight ? (
					<Label attached="bottom right" color="green">
						Preferred
					</Label>
				) : (
					false
				)}
			</Card.Content>
		</Card>
	)
}
TechnologyItem.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	logo: PropTypes.string,
	highlight: PropTypes.bool,
	types: PropTypes.arrayOf(PropTypes.string).isRequired,
	quote: PropTypes.string.isRequired,
	quoteSource: PropTypes.string.isRequired
}
function TechnologyGroup(props) {
	return (
		<div>
			<h3>{props.title}</h3>
			<p>{props.description}</p>
			<Card.Group>
				{props.technologies.map(tech => <TechnologyItem key={tech.title} {...tech} />)}
			</Card.Group>
		</div>
	)
}
TechnologyGroup.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	technologies: PropTypes.arrayOf(PropTypes.object).isRequired
}
export default class TechnologiesSection extends Component {
	render() {
		// Most will have only one type, though some may fall under multiple
		const slides = [
			/*
			{
				url: '',
				logo: '',
				types: [''],
				title: '',
				quote: '',
				quoteSource: '',

			},
			*/
			{
				url: 'lodash',
				logo: 'lodash.svg',
				types: ['JavaScript Stuff'],
				title: 'Lodash',
				quote:
					'A modern JavaScript utility library delivering modularity, performance & extras',
				quoteSource: 'https://lodash.com/'
			},
			{
				url: 'eslint',
				highlight: true,
				logo: 'eslint.svg',
				types: ['JavaScript Stuff'],
				title: 'ESLint',
				quote: 'The pluggable linting utility for JavaScript and JSX',
				quoteSource: 'http://eslint.org/'
			},
			{
				url: 'prettier',
				logo: 'prettier-icon-light.svg',
				types: ['JavaScript Stuff'],
				title: 'Prettier',
				highlight: true,
				quote:
					'Prettier is an opinionated code formatter inspired by refmt with advanced support for language features',
				quoteSource: 'https://github.com/prettier/prettier'
			},
			{
				url: 'moment',
				highlight: true,
				logo: 'momentjs.svg',
				types: ['JavaScript Stuff'],
				title: 'Moment.js',
				quote: 'Parse, validate, manipulate, and display dates and times in JavaScript',
				quoteSource: 'https://momentjs.com/'
			},
			{
				url: 'meteor',
				logo: 'meteor.svg',
				highlight: true,
				types: ['Frameworks'],
				title: 'Meteor',
				quote:
					'Meteor is a full-stack JavaScript platform for developing modern web and mobile applications.',

				quoteSource: 'https://guide.meteor.com/'
			},
			{
				url: 'metalsmith',
				logo: '',
				types: ['Content Management'],
				highlight: true,
				title: 'MetalSmith',
				quote: 'An extremely simple, *pluggable* static site generator',
				quoteSource: 'http://www.metalsmith.io/'
			},
			{
				url: 'keystone',
				logo: 'keystonejs.svg',
				types: ['Content Management'],
				highlight: true,
				title: 'Keystone',
				quote:
					'The open source framework for developing database-driven websites, applications and APIs in Node.js.',
				quoteSource: 'http://keystonejs.com/'
			},
			{
				url: 'virtualBox',
				logo: 'Virtualbox_logo.png',
				types: ['Tools'],
				title: 'Virtual Box',
				quote: 'VirtualBox is a general-purpose full virtualizer for x86 hardware',
				quoteSource: 'https://www.virtualbox.org/'
			},
			{
				url: 'npm',
				logo: 'npm.svg',
				highlight: true,
				types: ['Tools'],
				title: 'NPM',
				quote:
					'npm is the package manager for JavaScript and the worlds largest software registry',
				quoteSource: 'https://www.npmjs.com/'
			},
			{
				url: 'meteorGalaxy',
				logo: 'mongodb.svg',
				highlight: true,
				types: ['Hosts'],
				title: 'Meteor Galaxy',
				quote:
					'Galaxy is the only platform-as-a-service built specifically for Meteor apps',
				quoteSource: 'https://www.meteor.com/hosting'
			},
			{
				url: 'cloudflare',
				highlight: true,
				logo: 'cloudflare.svg',
				types: ['Hosts'],
				title: 'Cloudflare',
				quote:
					'Offering CDN, DNS, DDoS protection and security, find out how we can help your site',
				quoteSource: 'https://www.cloudflare.com/'
			},
			{
				url: 'mongoDBAtlas',
				highlight: true,
				logo: 'mongodb.svg',
				types: ['Hosts'],
				title: 'MongoDB Atlas',
				quote: 'The best way to deploy, operate, and scale MongoDB in the cloud',
				quoteSource: 'https://www.mongodb.com/'
			},
			{
				url: 'thinkpad',
				logo: 'lenovo-laptop-thinkpad-x260-cover-1.jpg',
				types: ['Tools'],
				title: 'ThinkPad',
				quote: 'ThinkPad is a line of laptop computers and tablets developed by Lenovo',
				quoteSource: 'https://en.wikipedia.org/wiki/ThinkPad'
			},
			{
				url: 'mysql',
				logo: 'mysql.svg',
				highlight: true,
				title: 'MySQL',
				types: ['Databases'],
				quote: "MySQL is the world's most popular open source database",
				quoteSource: 'https://www.mysql.com/'
			},
			{
				url: 'redis',
				logo: 'redis.svg',
				title: 'Redis',
				types: ['Databases'],
				quote:
					'Redis is an open source (BSD licensed), in-memory data structure store, used as a database, cache and message broker',
				quoteSource: 'https://redis.io/'
			},
			{
				url: 'postgre',
				logo: 'postgresql.svg',
				title: 'PostgreSQL',
				types: ['Databases'],
				quote: 'PostgreSQL is a powerful, open source object-relational database system',
				quoteSource: 'https://www.postgresql.org/'
			},
			{
				url: 'mariadb',
				logo: 'mariadb.svg',
				title: 'MariaDB',
				types: ['Databases'],
				quote:
					'One of the most popular database servers. Made by the original developers of MySQL. Guaranteed to stay open source.',
				quoteSource: 'https://mariadb.org/'
			},
			{
				url: 'firebase',
				logo: 'firebase.svg',
				highlight: true,
				types: ['Databases', 'APIs', 'Hosts'],
				title: 'Firebase',
				quote:
					"Firebase is Google's mobile platform that helps you quickly develop high-quality apps and grow your business.",
				quoteSource: 'https://firebase.google.com/'
			},
			{
				url: 'mongoDB',
				logo: 'mongodb.svg',
				highlight: true,
				types: ['Databases'],
				title: 'MongoDB',
				quote:
					'MongoDB is a document database with the scalability and flexibility that you want with the querying and indexing that you need',
				quoteSource: 'https://www.mongodb.com/'
			},
			{
				url: 'php',
				logo: 'php.svg',
				types: ['Languages'],
				title: 'PHP',
				quote:
					'PHP: Hypertext Preprocessor. PHP is a popular general-purpose scripting language that is especially suited to web development',
				quoteSource: 'https://php.net/'
			},
			{
				url: 'javascript',
				logo: 'javascript.svg',
				highlight: true,
				types: ['Languages'],
				title: 'JavaScript',
				quote:
					'JavaScript, often abbreviated as "JS", is a high-level, dynamic, untyped, interpreted run-time language',
				quoteSource: 'https://en.wikipedia.org/wiki/JavaScript'
			},
			{
				url: 'bash',
				logo: 'bash.svg',
				types: ['Languages'],
				title: 'Bash Scripting',
				quote:
					'Bash is a command processor that typically runs in a text window, where the user types commands that cause actions',
				quoteSource: 'https://en.wikipedia.org/wiki/Bash_(Unix_shell)'
			},
			{
				url: 'html',
				logo: 'html-5.svg',
				types: ['Languages'],
				title: 'HTML',
				quote:
					'Hypertext Markup Language (HTML) is the standard markup language for creating web pages and web applications',
				quoteSource: 'https://en.wikipedia.org/wiki/HTML'
			},
			{
				url: 'css',
				logo: 'css-3.svg',
				types: ['Languages'],
				title: 'CSS',
				quote:
					'Cascading Style Sheets (CSS) is a style sheet language used for describing the presentation of a document written in a markup language',
				quoteSource: 'https://en.wikipedia.org/wiki/Cascading_Style_Sheets'
			},
			{
				url: 'cakephp',
				logo: 'cakephp.svg',
				types: ['Frameworks'],
				title: 'CakePHP',
				quote:
					'CakePHP is an open-source web, rapid development framework that makes building web applications simpler, faster and require less code',
				quoteSource: 'https://cakephp.org/'
			},
			{
				url: 'bootstrap',
				logo: 'bootstrap.svg',
				types: ['Frameworks'],
				title: 'Bootstrap',
				quote:
					'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web',
				quoteSource: 'https://getbootstrap.com/'
			},
			{
				url: 'semanticUi',
				logo: 'semantic-ui.svg',
				highlight: true,
				types: ['Frameworks'],
				title: 'Semantic UI',
				quote:
					'Semantic is a development framework that helps create beautiful, responsive layouts using human-friendly HTML',
				quoteSource: 'https://semantic-ui.com/'
			},
			{
				url: 'jQuery',
				logo: 'jquery.svg',
				types: ['Frameworks', 'JavaScript Stuff'],
				title: 'jQuery',
				quote: 'jQuery is a fast, small, and feature-rich JavaScript library',
				quoteSource: 'https://jquery.com/'
			},
			{
				url: 'nodejs',
				logo: 'nodejs-icon.svg',
				types: ['Servers'],
				title: 'Node.js',
				highlight: true,
				quote: "Node.js is a JavaScript runtime built on Chrome's V8 JavaScript engine",
				quoteSource: 'https://nodejs.org/'
			},
			{
				url: 'apache',
				logo: 'apache.png',
				types: ['Servers'],
				title: 'Apache',
				quote:
					'The Apache HTTP Server Project is an effort to develop and maintain an open-source HTTP server for modern operating systems including UNIX and Windows',
				quoteSource: 'https://httpd.apache.org/'
			},
			{
				url: 'nginx',
				logo: 'nginx.svg',
				types: ['Servers'],
				title: 'nginx',
				quote:
					'nginx [engine x] is an HTTP and reverse proxy server, a mail proxy server, and a generic TCP/UDP proxy server, originally written by Igor Sysoev',
				quoteSource: 'https://nginx.org/en/'
			},
			{
				url: 'haproxy',
				types: ['Servers'],
				title: 'HAProxy',
				quote:
					'AProxy is a free, very fast and reliable solution offering high availability, load balancing, and proxying for TCP and HTTP-based applications',
				quoteSource: 'http://www.haproxy.org/'
			},
			{
				url: 'ubuntuServer',
				highlight: true,
				logo: 'ubuntu.svg',
				types: ['Servers'],
				title: 'Ubuntu Server',
				quote:
					'Ubuntu Server brings economic and technical scalability to your datacentre, public or private',
				quoteSource: 'https://www.ubuntu.com/server'
			},
			{
				url: 'centOSServer',
				logo: 'centos-icon.svg',
				types: ['Servers'],
				title: 'CentOS Server',
				quote:
					'The CentOS Linux distribution is a stable, predictable, manageable and reproducible platform derived from the sources of Red Hat Enterprise Linux (RHEL)',
				quoteSource: 'https://www.centos.org/about/'
			},
			{
				url: 'stripe',
				logo: 'stripe.svg',
				types: ['APIs'],
				title: 'Stripe',
				quote:
					'Stripe is a suite of APIs that powers commerce for businesses of all sizes',
				quoteSource: 'https://stripe.com/'
			},
			{
				url: 'facebookAPI',
				logo: 'facebook.svg',
				types: ['APIs'],
				title: 'Facebook API',
				quote:
					'Facebook Platform helps developers build, grow and monetize their business',
				quoteSource: 'https://developers.facebook.com/'
			},
			{
				url: 'googleMaps',
				logo: 'maps_64dp.png',
				types: ['APIs'],
				title: 'Google Maps',
				quote:
					'Millions of websites and apps use Google Maps APIs to power location experiences for their users',
				quoteSource: 'https://developers.google.com/maps/'
			},
			{
				url: 'amazonWebServices',
				logo: 'AmazonWebservices_Logo.svg',
				types: ['APIs', 'Hosts'],
				title: 'Amazon Web Services',
				quote:
					'Amazon Web Services offers reliable, scalable, and inexpensive cloud computing services',
				quoteSource: 'https://aws.amazon.com/'
				/*
				description:
					"I'm familiar with Mechanical Turk via their Node.js API and have played with their EC2/S3 hosting. It's easy enough for me to pick up more of their many offerings."
				*/
			},
			{
				url: 'git',
				logo: 'git-icon.svg',
				types: ['Tools'],
				title: 'GIT',
				highlight: true,
				quote:
					'Git is a free and open source distributed version control system designed to handle everything from small to very large projects with speed and efficiency',
				quoteSource: 'https://git-scm.com/'
			},
			{
				url: 'vim',
				logo: 'vim.svg',
				types: ['Tools'],
				title: 'VIM',
				highlight: true,
				quote:
					'Vim is a highly configurable text editor built to make creating and changing any kind of text very efficient',
				quoteSource: 'http://www.vim.org/'
			},
			{
				url: 'svn',
				logo: 'subversion.svg',
				types: ['Tools'],
				title: 'Subversion',
				quote: 'Subversion is an open source version control system',
				quoteSource: 'https://subversion.apache.org/'
			},
			{
				url: 'wordPress',
				types: ['Content Management'],
				logo: 'wordpress.svg',
				title: 'WordPress (Org)',
				quote:
					'WordPress is open source software you can use to create a beautiful website, blog, or app',
				quoteSource: 'https://wordpress.org/'
			},
			{
				url: 'ghost',
				logo: 'ghost.svg',
				types: ['Content Management'],
				title: 'Ghost',
				quote:
					'Ghost is an open source publishing platform which is beautifully designed, easy to use, and free for everyone',
				quoteSource: 'https://ghost.org/'
			},
			{
				url: 'digitalOcean',
				highlight: true,
				logo: 'digital-ocean.svg',
				types: ['Hosts'],
				title: 'Digital Ocean',
				quote:
					'DigitalOcean is a simple and robust cloud computing platform, designed for developers',
				quoteSource: 'https://www.digitalocean.com/'
			},
			{
				url: 'trelloAPI',
				logo: 'trello.svg',
				types: ['APIs'],
				title: 'Trello API',
				quote:
					'Trello keeps track of everything, from the big picture to the minute details',
				quoteSource: 'https://developers.trello.com/'
			},
			{
				url: 'react',
				highlight: true,
				logo: 'react.svg',
				types: ['Frameworks', 'JavaScript Stuff'],
				title: 'React',
				quote: 'A JavaScript library for building user interfaces',
				quoteSource: 'https://facebook.github.io/react/'
			}
		]

		const typeDescriptions = {
			APIs:
				"I've used these Application Programmer Interfaces (and more) to connect with 3rd party services",
			Databases: 'I can keep information in a variery of systems',
			Tools: 'Technical tools used day to day to make development easier',
			Languages:
				'I use these languages to speak to the computer and get it to do what you want it to',
			Hosts:
				'Computers or services in the cloud where I can easily put your web application',
			Frameworks: 'Tools that make my life as a web software developers easier',
			'Content Management':
				'Systems that make it easy to add and change content (like pictures, text, ...) on the web',
			Servers:
				"Layers that give your web app users what they're requesting from the code I write for you",
			'JavaScript Stuff':
				'A few of the common libraries and tools that help me with JavaScript development'
		}

		const types = _.uniq(_.flatten(slides.map(slide => slide.types)))
			.sort()
			.map(type => ({
				description: typeDescriptions[type],
				title: type,
				technologies: slides.filter(slide => _.includes(slide.types, type))
			}))

		return (
			<Slider
				title="Technologies"
				types={types}
				slides={types.map(slide => ({
					url: slide.title,
					title: slide.title,
					element: (
						<TechnologyGroup
							title={slide.title}
							technologies={_.sortBy(slide.technologies, 'title')}
							description={slide.description}
						/>
					)
				}))}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/sections/TechnologiesSection.js